/* @ngInject */
const constants = (

) => {
  const self = {}

  self.arrays = {
    positions: [
      '1 - 2',
      '3 - 4',
      '5 - 6',
      '7 - 8',
      '9 - 10',
      '11 - 12',
      '13 - 14',
      '15 - 16',
    ],
    decisions: [
      'Restitué',
      'Ferraillé',
    ],
  }

  self.ids = {
    arrivalArea: 1,
    departureArea: 2,
    arrivalRailway: 1,
    departureRailway: 2,
  }

  return self
}

export default constants



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/constants.resource.js